import AdminPage from './AdminPage';

export default function SettingsPage() {
  return <AdminPage settingsMode />;
}
